/* istanbul ignore file */
import DefaultLayout from './DefaultLayout';

export default DefaultLayout;
